// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .demo-overlay[data-v-5ab11aee]{position:absolute!important;bottom:0!important;left:0!important;z-index:4!important;background-image:url(https://js.static.parmonic.ai/static/demo-overlay.png)!important;background-repeat:no-repeat!important;background-size:contain!important;background-position-x:0!important;opacity:.8!important;width:100%!important;height:100%!important;max-height:35%!important;max-width:50%!important}", ""]);
// Exports
module.exports = exports;
